module.exports = __webpack_public_path__ + "img/JM.b8b18ced.svg";